import { AccessChecker } from 'mycorems-app-accounts';
import rules from './rules';

const accessChecker = new AccessChecker(rules, 'roadmap');

export default function (action, args) {
  return accessChecker.isGranted(action, args);
}
